import { Fragment } from 'react'
import { Image } from '@/components/Image'
import styles from './Picture.module.scss'
import { getAppConfig } from '@/config/config'
import { clsx } from 'clsx'

export type WidgetPictureProps = {
  readonly model: {
    readonly fields: {
      readonly priority?: boolean
    }
  }
  readonly items: Array<{
    readonly id: string
    readonly publishedAt: string
    readonly model: {
      readonly fields: {
        readonly maximizable?: {
          readonly value?: string
        }
        readonly caption: {
          readonly value?: string
        }
      }
      readonly image: {
        readonly crop: string
        readonly filename: string
        readonly baseUrl: string
        readonly heightRatio: number
      }
      readonly imageAttributes?: {
        readonly credit?: string
        readonly title?: string
      }
    }
  }>
}

const cleanCaption = (caption: string): string => caption.replaceAll(/\S+\.(jpg|png|webp|jpeg)/gi, '').trim()

const Picture = ({ item, top }: { item: WidgetPictureProps | any; top?: boolean }) => {
  const config = getAppConfig()
  const basePath = config.basePath

  const pictures = Array.isArray(item.items) ? item.items : [item]

  return (
    <>
      {pictures?.map((item: any, index: number) => {
        const { baseUrl, filename } = item.model.image || {}
        const captionValue = item.model.fields.caption?.value
        const maximizable = item.model.fields.maximizable?.value === 'true'
        const cleanedCaption = captionValue ? cleanCaption(captionValue) : ''

        return (
          <Fragment key={index}>
            <figure className={clsx(styles.picture, top && styles['picture-top'])}>
              {baseUrl && (
                <Image
                  image={item.model.image}
                  alt={filename}
                  defaultWidth={1200}
                  fallbackImage={`${basePath}/assets/logos/logo_grey.svg`}
                  priority={top || !!item.model.fields.priority}
                  className={`${maximizable ? styles.maximizable : ''}`}
                />
              )}
              <figcaption className={clsx(top && styles['figcaption-top'])}>
                {cleanedCaption && `${cleanedCaption} `}
                {item.model.imageAttributes?.credit && <>(Foto: {item.model.imageAttributes.credit})</>}
              </figcaption>
            </figure>
          </Fragment>
        )
      })}
    </>
  )
}

export default Picture
